// Every TanStack Query key in one place, so invalidation and the poll share
// one spelling. Screen packages add their keys here, keyed by aggregate.
//
// `books` is the prefix of both the dashboard list and every Book detail, so
// one invalidateQueries({ queryKey: queryKeys.books }) after a mutation
// refreshes the card the Author is looking at and the list behind it.
export const queryKeys = {
  proposal: (bookId: string) => ["proposal", bookId] as const,
  styleSheet: (bookId: string) => ["styleSheet", bookId] as const,
  /** Where each term is spoken; keyed by the draft's terms, and by the term listed in detail. */
  termOccurrences: (bookId: string, terms: string, detailTerm?: number) =>
    detailTerm === undefined
      ? (["termOccurrences", bookId, terms] as const)
      : (["termOccurrences", bookId, terms, detailTerm] as const),
  voices: (language: string) => ["voices", language] as const,
  casting: (bookId: string) => ["casting", bookId] as const,
  sampleSource: (bookId: string, chapterId: string, revision: string) =>
    ["sampleSource", bookId, chapterId, revision] as const,
  estimate: (bookId: string) => ["estimate", bookId] as const,
  renderProgress: (bookId: string) => ["renderProgress", bookId] as const,
  audiobook: (bookId: string) => ["audiobook", bookId] as const,
  session: ["session"] as const,
  books: ["books"] as const,
  bookList: ["books", "list"] as const,
  book: (id: string) => ["books", "detail", id] as const,
  /**
   * One Chapter's alignment. The version is part of the key because Review can
   * show an older one beside the current one, and `current` is its own entry
   * rather than `undefined`: an edit forks a new version and answers with it,
   * and that answer has to land on the key the screen is reading.
   */
  chapterReview: (bookId: string, chapterId: string, versionId?: string) =>
    ["chapterReview", bookId, chapterId, versionId ?? "current"] as const,
  sample: (sampleId: string) => ["sample", sampleId] as const,
};
